import classNames from 'classnames';
import { isUndefined, omit } from 'lodash-es';
import type { TextareaHTMLAttributes, DetailedHTMLProps, PropsWithChildren } from 'react';
import { sanitizeString } from '../../form/form-utils';

type TextareaProps = Omit<DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, 'value'> & {
  value?: string | readonly string[] | number | undefined | null;
  onValueChange?: (value: string | undefined) => void;
};

export function Textarea(props: PropsWithChildren<TextareaProps>) {
  return (
    <textarea
      {...omit(props, 'onValueChange')}
      className={classNames(
        'block w-full tds-input-value tds-input-value-default tds-input-field tds-input-field-default',
        props.className,
      )}
      value={props.value ?? ''}
      onChange={event => {
        props.onValueChange?.(sanitizeString(event.target.value));
        if (!isUndefined(props.onChange)) {
          props.onChange(event);
        }
      }}
    />
  );
}
